const REGISTRATION_PHONE_KEY = 'ttc_registration_phone';

export const setRegistrationPhone = (phone: string) => {
  localStorage.setItem(REGISTRATION_PHONE_KEY, phone);
};

export const getRegistrationPhone = () => localStorage.getItem(REGISTRATION_PHONE_KEY);

export const clearRegistrationPhone = () => {
  localStorage.removeItem(REGISTRATION_PHONE_KEY);
};
